import { render, staticRenderFns } from "./modifyPsd.vue?vue&type=template&id=232fd050&scoped=true&"
import script from "./modifyPsd.vue?vue&type=script&lang=js&"
export * from "./modifyPsd.vue?vue&type=script&lang=js&"
import style0 from "./modifyPsd.vue?vue&type=style&index=0&id=232fd050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232fd050",
  null
  
)

export default component.exports